/* eslint-disable react/no-array-index-key */
import { FormField } from '@/types';
import Button from '@components/Button';
import Input from '@components/Form/Input';
import { useMemo, useState } from 'react';

import TrashIcon from './TrashIcon.svg';

type Counter = {
  type: string;
  number: string;
  count: string;
  yearly: string;
};

function CountersField(props: FormField) {
  const { clean_name, id, label, required, choices, removeYearInput, isCustomForm } = props;

  const splitted = useMemo(() => {
    if (choices.includes('\r\n')) {
      return choices.split('\r\n');
    }

    if (choices.includes('\n')) {
      return choices.split('\n');
    }

    return choices.split(',');
  }, [choices]);

  const [counters, setCounters] = useState<Counter[]>([
    { type: splitted?.[0] ?? '', number: '', count: '', yearly: '' },
  ]);

  return (
    <fieldset className='counters'>
      {!isCustomForm ? <legend className='counters__legend'>{label}</legend> : null}
      {counters.map((counter, index) => (
        <div key={index} className='counters__entry'>
          <fieldset className='counters__types'>
            <legend>Zählerart</legend>
            {splitted.map((choice, choiceIndex) => (
              <label
                className='counters__radio'
                htmlFor={`${id}-${index}-${choiceIndex}-type`}
                key={choice}
              >
                <input
                  type='radio'
                  name={`${id}-${index}-type`}
                  id={`${id}-${index}-${choiceIndex}-type`}
                  value={choice}
                  required={required}
                  checked={choice === counter.type}
                  onChange={e => {
                    setCounters(prev => {
                      const updated = [...prev];
                      updated[index].type = e.target.value;
                      return updated;
                    });
                  }}
                />
                {choice}
              </label>
            ))}
          </fieldset>
          <div className='counters__row'>
            <Input
              id={`${id}-${index}-number`}
              label='Zählernummer'
              value={counter.number}
              required={required}
              onChange={e => {
                setCounters(prev => {
                  const updated = [...prev];
                  updated[index].number = e.target.value;
                  return updated;
                });
              }}
            />
            <Input
              id={`${id}-${index}-count`}
              label='Zählerstand'
              value={counter.count}
              required={required}
              onChange={e => {
                setCounters(prev => {
                  const updated = [...prev];
                  updated[index].count = e.target.value;
                  return updated;
                });
              }}
            />
            {!removeYearInput ? (
              <Input
                id={`${id}-${index}-yearly`}
                label='Jahresverbrauch'
                value={counter.yearly}
                required={required}
                onChange={e => {
                  setCounters(prev => {
                    const updated = [...prev];
                    updated[index].yearly = e.target.value;
                    return updated;
                  });
                }}
              />
            ) : null}
          </div>
          {index > 0 ? (
            <button
              type='button'
              className='counters__delete-button'
              onClick={() =>
                setCounters(prev => {
                  const updated = [...prev];
                  updated.splice(index, 1);
                  return updated;
                })
              }
            >
              <TrashIcon color='var(--clr-warning-red)' width='40px' height='40px' />
            </button>
          ) : null}
        </div>
      ))}
      <Button
        type='button'
        onClick={() =>
          setCounters(prev => [
            ...prev,
            { number: '', count: '', type: splitted?.[0] ?? '', yearly: '' },
          ])
        }
      >
        Weiteren Zählerstand hinzufügen
      </Button>
      <textarea
        name={clean_name}
        id={`${id}-${clean_name}`}
        hidden
        tabIndex={-1}
        aria-hidden
        value={counters
          .map(
            counter =>
              `${counter.type} - ZN: ${counter.number} - ZS: ${counter.count} ${
                !removeYearInput ? `- JV: ${counter.yearly}` : ''
              }`,
          )
          .join('\n')}
        onChange={() => {}}
        required={required}
      />
    </fieldset>
  );
}

export default CountersField;
